import React, { useContext } from 'react';
import { FlexMiddle } from '../../Flex';
import ConfigContext from '../../../contexts/ConfigContext';

const HelpDeskAssigneesChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  const items = value ? (Array.isArray(value) ? value : [value]) : [];
  if (!items.length) return null;
  if (items.length > 1) return <FlexMiddle>{t('help_desk_n_assignees', { count: items.length })}</FlexMiddle>;
  return <FlexMiddle>{items[0]?.label ?? String(items[0]?.adminId ?? '')}</FlexMiddle>;
};

export default HelpDeskAssigneesChip;
